module.exports = __webpack_public_path__ + "static/img/hussar_aicode_face.6f15843.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentPage/hussar_aicode_face.webp
// module id = FvUq
// module chunks = 0